/**
 * Client-side search for a single filter group (e.g. manufacturer/vendor).
 * Scoped to any element marked with [data-facet-search-root]. Uses event
 * delegation on document so it survives Section Rendering API swaps and the
 * mobile filters drawer being moved around in the DOM.
 *
 * When the search box is empty the list behaves exactly as before (a few
 * items + a "show more" button). When the user types, every matching item is
 * revealed across the whole list and the "show more" button is hidden.
 */
(function () {
  'use strict';

  function normalize(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function getRoot(input) {
    return input.closest('[data-facet-search-root]');
  }

  function restore(root) {
    var items = root.querySelectorAll('[data-facet-search-item]');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.classList.contains('show-more-item')) {
        item.classList.add('hidden');
      } else {
        item.classList.remove('hidden');
      }
    }
    var showMore = root.querySelector('show-more-button');
    if (showMore) showMore.classList.remove('hidden');
    var empty = root.querySelector('[data-facet-search-empty]');
    if (empty) empty.classList.add('hidden');
  }

  function search(root, query) {
    var items = root.querySelectorAll('[data-facet-search-item]');
    var matches = 0;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var text = normalize(item.getAttribute('data-facet-search-text') || item.textContent);
      if (text.indexOf(query) !== -1) {
        item.classList.remove('hidden');
        matches++;
      } else {
        item.classList.add('hidden');
      }
    }
    var showMore = root.querySelector('show-more-button');
    if (showMore) showMore.classList.add('hidden');
    var empty = root.querySelector('[data-facet-search-empty]');
    if (empty) empty.classList.toggle('hidden', matches > 0);
  }

  function handle(input) {
    var root = getRoot(input);
    if (!root) return;
    var query = normalize(input.value);
    if (query === '') {
      restore(root);
    } else {
      search(root, query);
    }
  }

  document.addEventListener('input', function (event) {
    var target = event.target;
    if (target && target.classList && target.classList.contains('facet-search__input')) {
      handle(target);
    }
  });

  // Prevent Enter inside the search box from submitting the facet form.
  document.addEventListener('keydown', function (event) {
    var target = event.target;
    if (
      event.key === 'Enter' &&
      target &&
      target.classList &&
      target.classList.contains('facet-search__input')
    ) {
      event.preventDefault();
    }
  });
})();
